import { CapacityValue, TimePeriod, TimeRange } from '../../model/CORE';
import TimeRangeUtils from './TimeRangeUtils';
import TrafficCountUtils from './TrafficCountUtils';

export default class CapacityUtils {
    static getWcmCapacity(hourlyCapacity: Array<CapacityValue>, timeRange: TimeRange) {
        if (!timeRange) return hourlyCapacity;

        const adaptedHourlyCapacity = Array<CapacityValue>();
        let cv: CapacityValue = null;
        let tp: TimePeriod = null;
        for (let idx = 0; idx < TimeRangeUtils.getNumberOfSteps(timeRange); idx++) {
            tp = TimeRangeUtils.getCountingPeriodAtStep(timeRange, idx);
            const wcv = TrafficCountUtils.getWeightedHourlyCapacity(hourlyCapacity, tp);

            if (cv === null) {
                cv = wcv;
                adaptedHourlyCapacity.push(cv);
            } else if (cv.hourlyCapacity !== wcv.hourlyCapacity) {
                cv.timePeriod.to = wcv.timePeriod.from;
                cv = wcv;
                adaptedHourlyCapacity.push(cv);
            }
        }
        if (cv != null) cv.timePeriod.to = tp.to;

        return adaptedHourlyCapacity;
    }
}
